var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = /*#__PURE__*/ _createElementVNode("div", { class: "spacer" }, null, -1 /* HOISTED */);
var _hoisted_2 = ["disabled"];
import ItineraryFields from '../ItineraryFields/ItineraryFields.vue';
import { computed, inject, ref } from 'vue';
import { getItineraryScheduleParams } from '../../lib/createAmadeusActionQueryParams';
import AmadeusFormSubmission from '../AmadeusFormSubmission/AmadeusFormSubmission.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FlightSchedule',
    props: {
        buttonText: {
            type: String,
            default: '',
        },
    },
    setup: function (__props) {
        var _a, _b;
        var props = __props;
        var amadeusParams = (_a = inject('amadeus-params')) !== null && _a !== void 0 ? _a : {};
        var scheduleParams = (_b = inject('amadeus-schedule-params')) !== null && _b !== void 0 ? _b : {};
        var queryParams = computed(function () {
            var params = __assign(__assign({}, amadeusParams), scheduleParams);
            if (itineraries.value.length) {
                params = __assign(__assign({}, params), getItineraryScheduleParams(itineraries.value));
            }
            return params;
        });
        var isButtonDisabled = computed(function () {
            for (var _i = 0, _a = itineraries.value; _i < _a.length; _i++) {
                var itinerary = _a[_i];
                if ((!itinerary.departureDate || !itinerary.fromAirport || !itinerary.toAirport) && !itinerary.ignore) {
                    return true;
                }
            }
            return false;
        });
        var itineraries = ref([{}, {}]);
        var submit = function () {
            if (isButtonDisabled.value) {
                return false;
            }
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _renderSlot(_ctx.$slots, "default"),
                _createVNode(ItineraryFields, {
                    itineraries: itineraries.value,
                    "show-cabin-class": false,
                    "conditional-second-row": false,
                    "allow-multi-city": false,
                    "show-prices": false
                }, null, 8 /* PROPS */, ["itineraries"]),
                _hoisted_1,
                _createVNode(AmadeusFormSubmission, { params: queryParams.value }, {
                    default: _withCtx(function () { return [
                        _createElementVNode("button", {
                            class: "button button--primary manage-booking__button",
                            type: "submit",
                            disabled: isButtonDisabled.value
                        }, _toDisplayString(__props.buttonText), 9 /* TEXT, PROPS */, _hoisted_2)
                    ]; }),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["params"])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
